import { jsx as _jsx } from "react/jsx-runtime";
import { css } from '@emotion/css';
const Spinner = (props) => (_jsx("div", { className: props.cx('spinner', css(props.getStyles('spinner'))), children: _jsx("svg", { viewBox: "25 25 50 50", children: _jsx("circle", { cx: "50", cy: "50", r: "20", fill: "none", strokeWidth: "2", strokeMiterlimit: "10" }) }) }));
export default Spinner;
//# sourceMappingURL=Spinner.js.map